import MAP_USER from './alerts/MapUser'

const state = {
  alerts: [],
  messages: []
}

const getters = {
  COUNT_ALERTS: state => state.alerts.length,
  COUNT_MESSAGES: state => state.messages.length
}

const mutations = {
  SET_ALERTS: (state, alerts) => { state.alerts = alerts },
  SET_MESSAGES: (state, messages) => { state.messages = messages }
}

const actions = {
  MAP_USER
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/brain/realtime/index.js